module.exports = __webpack_public_path__ + "img/kit-banner.81712acc.png";